import { useParams } from 'react-router-dom'
import classes from './NoticeEdit.module.scss'
import { useEffect, useState } from 'react'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers'
import { ja } from 'date-fns/locale' // 日本語ロケールをインポート
import { makeStyles } from '@material-ui/styles'
import {
  FormControlLabel,
  TextField,
  Typography,
  useMediaQuery,
} from '@material-ui/core'
import { Switch } from '@mui/material'
import { AttachFile } from '@material-ui/icons'
import DeleteIcon from '@material-ui/icons/Delete'
import { db, storage, FirebaseTimestamp } from '../../firebase'
import { collection, updateDoc, getDocs, doc, getDoc } from 'firebase/firestore'
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage'
import { formatDate } from '../../functions/utils/formatting'
import { uploadBase64ImagesAndReplaceUrls } from '../../functions/utils/imageUpload'
import FromToDatePickersForNotice from '../../components/Calendar/FromToDatePickersForNotice'
import Editor from '../../components/notice/Editor'
import DialogButton from '../../components/UIkit/DialogButton'
import { categories, publishStatuses } from '../../constants/notice'
import { push } from 'connected-react-router'
import { useDispatch, useSelector } from 'react-redux'
import Hero from '../../components/notice/Hero'
import {
  hideLoadingAction,
  showLoadingAction,
} from '../../reducks/loading/actions'
import { getUserInfo } from '../../reducks/users/selectors'
import SelectBoxForNotice from '../../components/UIkit/SelectBoxForNotice'
const useStyles = makeStyles(() => ({
  datePicker: {
    width: (props) => (props.isMobile ? '80px' : '110px'),
    '& .MuiInputBase-input': {
      paddingTop: 0,
      paddingBottom: 0,
      height: '32px',
      fontSize: '14px',
      width: (props) => (props.isMobile ? '80px' : '110px'),
    },
    '& .MuiInputLabel-root': {
      fontSize: '14px',
      color: '#4dd0e1',
      width: (props) => (props.isMobile ? '80px' : '110px'),
    },
  },
  switchBase: {
    color: '#4dd0e1', // 未チェック時の色
    '&.Mui-checked': {
      color: '#4dd0e1', // チェック時の色
    },
    '&.Mui-checked + .MuiSwitch-track': {
      backgroundColor: '#4dd0e1', // トラックの色
    },
  },
  label: {
    fontSize: '12px',
    color: '#4dd0e1',
  },
}))

const getEndDate = (date) => {
  const oneWeekLater = new Date(date)
  oneWeekLater.setDate(oneWeekLater.getDate() + 7)
  return oneWeekLater
}

const getStartDate = (date) => {
  return new Date()
}

const NoticeEdit = () => {
  const isMobile = useMediaQuery('(max-width:960px)')
  const userInfo = useSelector(getUserInfo)
  const styles = useStyles({ isMobile })
  const { slug } = useParams()
  const dispatch = useDispatch()
  useEffect(() => {
    const fetchArticle = async () => {
      if (!slug) {
        dispatch(push('/notice/list'))
        return
      }
      try {
        dispatch(showLoadingAction('記事を読込み中...'))
        const docRef = doc(db, 'articles', slug)
        const docSnap = await getDoc(docRef)

        if (docSnap.exists()) {
          const articleData = docSnap.data()

          setTitle(articleData.title)
          setCreatedAt(new Date(articleData.createdDay))
          setCategory(articleData.category)
          setPublishStatus(articleData.publishStatus)
          setIsNotice(articleData.notice)
          setContent(articleData.content)
          setNoticeFromDate(new Date(articleData.noticeFromDate))
          setNoticeToDate(new Date(articleData.noticeToDate))
          setAttachedFiles(
            articleData.attachedFiles.map((url, index) => ({
              url,
              name: articleData.attachedFilesName[index],
            }))
          )
        } else {
          console.log('指定された記事が見つかりませんでした。')
          dispatch(push('/notice/list'))
        }
      } catch (error) {
        console.error('記事の取得中にエラーが発生しました:', error)
        dispatch(push('/notice/list'))
      } finally {
        dispatch(hideLoadingAction())
      }
    }

    fetchArticle()
  }, [slug, dispatch])

  //更新ユーザ
  const [updateUserEmail, setUpdateUserEmail] = useState(
    userInfo ? userInfo.email : ''
  )
  useEffect(() => {
    setUpdateUserEmail(userInfo.email)
  }, [userInfo.email])
  //タイトル
  const [title, setTitle] = useState('')
  //作成日
  const [createdAt, setCreatedAt] = useState(new Date())
  //カテゴリ
  const [category, setCategory] = useState('お知らせ')
  //公開区分
  const [publishStatus, setPublishStatus] = useState('公開')
  //通知
  const [isNotice, setIsNotice] = useState(false)
  //記事
  const [content, setContent] = useState('')
  const [noticeFromDate, setNoticeFromDate] = useState(getStartDate(new Date()))
  const [noticeToDate, setNoticeToDate] = useState(getEndDate(new Date()))
  //添付ファイル
  const [attachedFiles, setAttachedFiles] = useState([])

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files)
    const filesWithPreview = files.map((file) => {
      return {
        file, // File オブジェクトそのもの
        name: file.name,
        url: URL.createObjectURL(file), // プレビュー用の URL を生成
      }
    })
    setAttachedFiles((prevFiles) => [...prevFiles, ...filesWithPreview])
  }

  const handleRemoveFile = (index) => {
    setAttachedFiles((prevFiles) => {
      const fileToRemove = prevFiles[index]
      if (fileToRemove.url && fileToRemove.url.startsWith('blob:')) {
        URL.revokeObjectURL(fileToRemove.url)
      }
      const newFiles = [...prevFiles]
      newFiles.splice(index, 1)
      return newFiles
    })
  }
  useEffect(() => {
    return () => {
      attachedFiles.forEach((file) => {
        if (file.url && file.url.startsWith('blob:')) {
          URL.revokeObjectURL(file.url)
        }
      })
    }
  }, [attachedFiles])
  // const save = async () => {
  //   /**
  //    * firestorageに添付ファイルを保存する
  //    * 保存先のフォルダは`notices/attached/‘とする
  //    * 保存したファイルのURLを取得する
  //    * firestoreに記事情報を保存する
  //    * コレクション名は`notices`とする
  //    * フィールドは以下の通り
  //    * title: タイトル
  //    * createdDay: 作成日
  //    * catory: カテゴリ
  //    * publishStatus: 公開区分
  //    * notice: 通知
  //    * noticeFromDate: 通知開始日
  //    * noticeToDate: 通知終了日
  //    * content: 記事
  //    * attachedFiles: 添付ファイルのURL(配列)
  //    * addatchedFilesName: 添付ファイルの名前(配列)
  //    * createdAt: 作成日時
  //    * updatedAt: 更新日時
  //    * updateUser: 更新者
  //    */
  // };

  const save = async () => {
    try {
      dispatch(showLoadingAction('記事を保存中...'))

      // エディタ内のbase64画像をStorageにアップロードしてURLに置き換え
      const processedContent = await uploadBase64ImagesAndReplaceUrls(
        content,
        slug
      )

      // 新しく追加されたファイルをアップロード
      const newFiles = attachedFiles.filter((file) => file.file instanceof File)
      const uploadedFiles = await Promise.all(
        newFiles.map(async (file) => {
          const uniqueId =
            Date.now() + '_' + Math.random().toString(36).substr(2, 9)
          const uniqueName = `${uniqueId}_${file.name}`
          const storageRef = ref(storage, `notices/attached/${uniqueName}`)
          await uploadBytes(storageRef, file.file)
          const downloadURL = await getDownloadURL(storageRef)
          return {
            url: downloadURL,
            name: file.name,
          }
        })
      )
      // 既存のファイルと新しくアップロードしたファイルを結合
      const existingFiles = attachedFiles.filter(
        (file) => !file.file || !(file.file instanceof File)
      )
      const allFiles = [...existingFiles, ...uploadedFiles]

      const attachedFileURLs = allFiles.map((file) => file.url)
      const attachedFileNames = allFiles.map((file) => file.name)
      // usersコレクションから全ユーザーのメールアドレスを取得
      const usersSnapshot = await getDocs(collection(db, 'users'))
      const targetUsers = usersSnapshot.docs.map((doc) => ({
        email: doc.data().email,
        isOpened: false,
      }))

      // Firestoreに保存するデータを準備
      const data = {
        title,
        createdDay: formatDate(createdAt),
        category,
        publishStatus,
        notice: isNotice,
        noticeFromDate: formatDate(noticeFromDate),
        noticeToDate: formatDate(noticeToDate),
        content: processedContent, // 処理済みのcontentを使用
        attachedFiles: attachedFileURLs,
        attachedFilesName: attachedFileNames,
        createdAt: FirebaseTimestamp.now(),
        updatedAt: FirebaseTimestamp.now(),
        updateUser: updateUserEmail,
        targetUsers,
      }

      // Firestoreに記事情報を保存
      // Firestoreに記事情報を保存（自動生成されたIDを取得）
      const docRef = doc(db, 'articles', slug)
      await updateDoc(docRef, data)

      dispatch(push('/notice/list'))
    } catch (error) {
      console.error('記事の保存中にエラーが発生しました:', error)
      alert('記事の保存中にエラーが発生しました。')
    } finally {
      dispatch(hideLoadingAction())
    }
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={ja}>
      <div className={classes.root}>
        <Hero title="記事編集" />
        <div className={classes.main}>
          {/* タイトル */}
          <div className={classes.title}>
            <label className={classes.label} htmlFor="title">
              タイトル
            </label>
            <input
              className={classes.input}
              type="text"
              id="title"
              name="title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>
          <div className={classes.attributes}>
            <div className={classes.first}>
              {/* 日付 */}
              <DatePicker
                label={`日付`}
                value={createdAt}
                onChange={(e) => setCreatedAt(e)}
                inputFormat="yyyy/MM/dd"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className={styles.datePicker}
                    style={{ width: isMobile ? '80px' : '110px' }}
                  />
                )}
                slotProps={{ calendarHeader: { format: 'YYYY年MM月' } }}
              />
              {/*カテゴリ */}
              <SelectBoxForNotice
                label={'カテゴリ'}
                options={categories}
                required={true}
                select={(e) => setCategory(e)}
                value={category}
                width="140px"
                height="50px"
                color="#4dd0e1"
                fontSize="14px"
                labelFontSize="14px"
              />
            </div>
            {/*公開設定 */}
            <div className={classes.second}>
              <div className={classes.publish}>
                <SelectBoxForNotice
                  label={'公開区分'}
                  options={publishStatuses}
                  required={true}
                  select={(e) => setPublishStatus(e)}
                  value={publishStatus}
                  width="120px"
                  height="50px"
                  color="#4dd0e1"
                  fontSize="14px"
                  labelFontSize="14px"
                />
              </div>
              <div className={classes.notice}>
                {/**お知らせ */}
                <FormControlLabel
                  label={<Typography className={styles.label}>通知</Typography>}
                  labelPlacement="start"
                  control={
                    <Switch
                      checked={isNotice}
                      onChange={(e) => setIsNotice(e.target.checked)}
                      sx={{
                        switchBase: styles.switchBase,
                      }}
                    />
                  }
                />
                <FromToDatePickersForNotice
                  setFromDate={setNoticeFromDate}
                  setToDate={setNoticeToDate}
                  fromDate={noticeFromDate}
                  toDate={noticeToDate}
                  disabled={!isNotice}
                />
              </div>
            </div>
          </div>
          <div className={classes.hr}></div>
          {/* 内容 */}
          <p className={classes.label}>記事</p>
          <div className={classes.contents}>
            <Editor content={content} setContent={setContent} />
          </div>
          <div className={classes.hr}></div>
          {/*添付ファイル*/}
          <div className={classes.attached}>
            <label className={classes.attachedLabel} htmlFor="attachFiles">
              <AttachFile className={classes.icon} />
              注文書（PDF）を添付
            </label>
            <input
              type="file"
              id="attachFiles"
              name="attachFiles"
              multiple
              onChange={handleFileChange}
              style={{ display: 'none' }}
            />
            <div className={classes.fileArea}>
              {attachedFiles.length > 0 && (
                <div className={styles.fileList}>
                  {attachedFiles.map((file, index) => (
                    <div key={index} className={classes.fileItem}>
                      {file.url ? (
                        <a
                          href={file.url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {file.name}
                        </a>
                      ) : (
                        <span>{file.name}</span>
                      )}
                      <button
                        onClick={() => handleRemoveFile(index)}
                        className={classes.icon}
                      >
                        <DeleteIcon />
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          {/* 保存ボタン */}
          <div className={classes.buttons}>
            <DialogButton label={'保存する'} onClick={save} mode="yes" />
            <DialogButton
              label={'一覧に戻る'}
              onClick={() => dispatch(push('/notice/list'))}
              mode="no"
            />
          </div>
        </div>
      </div>
    </LocalizationProvider>
  )
}

export default NoticeEdit
